import axios from "axios";
import { apiUrl } from "features/configure";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";

export default function useGetXFeed() {
  const [feed, setFeed] = useState([]);
  const { campaignId, sharedEntityName } = useParams();
  const outletContext = useOutletContext();
  const entityName = sharedEntityName || outletContext?.[0];
  const [isLoading, setIsLoading] = useState(false);
  const [sort, setSort] = useState({});
  const dispatchSnackbar = useDispatchSnackbar();

  const getXFeed = async () => {
    try {
      setIsLoading(true);
      const endpoint = sharedEntityName
        ? `${apiUrl}/api/x/shared/${sharedEntityName}/campaign/${campaignId}/feed${
            sort ? `?sort=${sort.sort}&order=desc` : ""
          }`
        : `${apiUrl}/api/x/${entityName}/campaign/${campaignId}/feed${
            sort ? `?sort=${sort.sort}&order=desc` : ""
          }`;

      const { data } = await axios(endpoint);
      setFeed(data);
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getXFeed();
  }, [sort]);

  return { feed, isLoading, sort, setSort };
}
